import displayAlertsUrl from './displayAlerts.html';

export default {
  templateUrl: displayAlertsUrl,
};
